<template>
  <div>
    <v-card v-if="blog.id" class="mx-auto">
      <v-img
        :src="
          blog.photo
            ? apiDomain + blog.photo
            : 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg'
        "
        height="200px"
      ></v-img>

      <v-card-title v-text="blog.title"> </v-card-title>

      <v-card-subtitle>
        {{ blog.description }}
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      blog: {},
      apiDomain: "https://demo-api-vue.sanbercloud.com",
    };
  },
  created() {
    this.getBlog();
  },
  methods: {
    getBlog() {
      let { id } = this.$route.params;

      const config = {
        method: "get",
        url: `${this.apiDomain}/api/v2/blog/${id}`,
      };

      this.axios(config)
        .then((response) => {
          let { blog } = response.data;
          this.blog = blog;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>